import { nextMonday } from 'date-fns';

// This function is used to get the current date and time, and if it's a weekend (Saturday or Sunday), it returns the next Monday.
// The application only allows planning visits on weekdays.
export const getToday = (): Date => {
  const today = new Date();
  today.setHours(12, 0, 0, 0);
  if (today.getDay() === 6 || today.getDay() === 0) {
    return nextMonday(today);
  }
  return today;
};
